import BaseService from "@/api/services/BaseService";
import type ServiceInterface from "@/api/services/ServiceInterface";
import type { LogsParamsDownload } from "@/types/logs";

import { useUrlHelper } from "@/mixins/urlHelper";
const { addParams } = useUrlHelper();

export default class ServiceLogs
  extends BaseService
  implements ServiceInterface
{
  async getBoots(): Promise<any[]> {
    const response = await this.rest.request({
      url: "/api/system/logs/boots",
      method: "get",
    });
    const data = response.data;
    return data || [];
  }

  async getServices(): Promise<any[]> {
    const response = await this.rest.request({
      url: "/api/system/logs/services",
      method: "get",
    });
    const data = response.data;
    return data || [];
  }

  async downloadLogs(params: LogsParamsDownload): Promise<any> {
    const headers = {
      //'accept': 'text/plain',
      'Content-Type': 'text/plain',
    }

    let url = '/api/system/logs';
    url = addParams(params, url);

    const response = await this.rest.request({
      url: url,
      method: "get",
      data: {}, // It's necessary for send headers
      responseType: 'blob',
      headers: headers
    });
    return {'data': response.data, 'headers': response.headers};
  }
}
